import React from "react";
import {
  Box,
  Wrap,
  WrapItem,
  Avatar as ChakraAvatar
} from "@chakra-ui/react";

import {
  Text,
  TextProps
} from "src/components/text";
import { getColour } from "src/utils/getAvatarColour";

interface AvatarProps {
  name: string;
  hideName?: boolean
  nameTextProps?: TextProps
  src?: string;
  size?: string;
  description?: string;
  descriptionTextProps?: TextProps;
}
export const Avatar: React.FC<AvatarProps> = ({
  name, hideName, nameTextProps, src, size, description, descriptionTextProps
}) => {
  return (
    <Wrap
      spacing={3}
      align="center"
    >
      <WrapItem>
        <ChakraAvatar
          border={`0.20rem solid ${getColour(name)}`}
          size={size || "md"}
          src={src}
        />
      </WrapItem>

      {!hideName && (

        <WrapItem>
          <Box
            display="flex"
            flexDir="column"
          >
            {!hideName && (
              <Text
                {...nameTextProps}
              >
                {name}
              </Text>
            )}

            <Text {...descriptionTextProps}>
              {description}
            </Text>
          </Box>
        </WrapItem>
      )}
    </Wrap>
  );
};